export default __webpack_public_path__ + "static/media/hht2_Intonation_12.f26aa629.png";